import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { Card } from "antd";
import Sidebar from "../../components/sidebar";
import Content from "./content";
import { FaRegUserCircle } from "react-icons/fa";
import {
  allTech,
  techDetails,
  techPagination,
  searchTech,
} from "../../functions/technicians";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import "../workOrder/index.css";
import { useDispatch, useSelector } from "react-redux";
import { loaderReducer } from "../../components/toolkit/loader";
import TechSidebar from "../../components/sidebar/techSidebar";

const Index = () => {
  const [activeEdit, setActiveEdit] = useState(false);
  const [allTechd, setAllTechd] = useState([]);
  const [techUsers, setTechUsers] = useState([]);
  const [techAllDetails, setTechAllDetails] = useState([]);
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [refreshData, setRefreshData] = useState("");
  const [openOrders, setOpenOrders] = useState([]);
  const dispatch = useDispatch();
  const [pageC, setPageC] = useState(1);
  const [totaltech, setTotaltech] = useState(1);
  const [updateEmail, setUpdateEmail] = useState("");
  const [searchData, setSearchData] = useState("");

  const [updateTech, setUpdateTech] = useState(
    []
    //   {
    //   _id: "",
    //   name: "",
    //   techId: "",
    //   email: "",
    //   password: "",
    //   role: "",
    // }
  );

  const cookies = new Cookies();
  const token = cookies.get("token");

  const handleActiveEdit = (e) => {
    e.preventDefault();
    setActiveEdit(!activeEdit);
  };

  const allTechdata = async () => {
    dispatch(loaderReducer(true));
    try {
      await techPagination(token, pageC)
        .then((res) => {
          // console.log(res);
          setAllTechd(res.data.technicians);
          setTotaltech(res.data.total);
          dispatch(loaderReducer(false));
          setSelectedCardIndex(0);
        })
        .catch((err) => {
          toast.error(err);
          dispatch(loaderReducer(false));
        });
    } catch (error) {
      toast.error(error);
      dispatch(loaderReducer(false));
    }
  };

  useEffect(() => {
    allTechdata();
  }, [token, refreshData, pageC, updateEmail]);

  // console.log(
  //   "refreshData",

  //   refreshData
  // );

  useEffect(() => {
    const techUsersData = allTechd;
    setTechUsers(techUsersData);
    // console.log("allTechd====>>>", allTechd);
    if (techUsersData.length > 0) {
      const { _id, name, techId, email, password, role } = techUsersData[0];
      setTechAllDetails(techUsersData[0]);
      setUpdateTech({ _id, name, techId, email, password, role });
    }
  }, [allTechd, updateEmail]);

  //getting userDetails
  const clickHandler = async (index, id) => {
    setSelectedCardIndex(index);
    dispatch(loaderReducer(true));
    setActiveEdit(false);
    try {
      await techDetails(token, id)
        .then((res) => {
          setTechAllDetails(res.data.user);
          const { _id, name, techId, email, password, role } = res.data.user;
          setUpdateTech(res.data.user);
          dispatch(loaderReducer(false));
        })
        .catch((err) => {
          toast.error("Getting some issue, try again." || err);
          dispatch(loaderReducer(false));
        });
    } catch (error) {
      toast.error("Getting some issue, try again." || error);
      dispatch(loaderReducer(false));
    }
  };

  console.log("117===>techAllDetails", techAllDetails, updateTech);
  //Exit without Saving -----------------------------------------------
  const handleExitwithoutSaving = (e) => {
    // e.preventDefault();
    setActiveEdit(!activeEdit);
    allTechdata();
    // clickHandler();
    setSelectedCardIndex(0);
  };

  // useEffect(() => {
  //   clickHandler(0, techAllDetails._id);
  // }, [updateEmail]);

  //---------------------Search input------------------------------
  useEffect(() => {
    dispatch(loaderReducer(true));
    const handleSearch = async () => {
      try {
        if (searchData.length > 0) {
          await searchTech(token, searchData)
            .then((res) => {
              // console.log("res=>", res);
              setAllTechd(res.data.data);
              setTotaltech(res.data.data.length);
              dispatch(loaderReducer(false));
            })
            .catch((err) => {
              toast.error(err);
              dispatch(loaderReducer(false));
            });
        } else {
          allTechdata();
        }
      } catch (error) {
        toast.error(error);
        dispatch(loaderReducer(false));
      }
    };

    handleSearch();
  }, [searchData]);

  const sidebarData = () =>
    techUsers.length === 0
      ? "No data found"
      : techUsers &&
        techUsers.map((d, i) => (
          <div
            className={`mt-3 ${selectedCardIndex === i ? "selected-card" : ""}`}
            // className="mt-3"
            key={i}
          >
            <Card
              hoverable
              className="cardcls"
              onClick={() => clickHandler(i, d._id)}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="prioritycls text-dark p-0">
                  <span style={{ fontSize: "24px" }}>
                    <FaRegUserCircle />
                  </span>
                  &nbsp;&nbsp;
                  {`${d.name}`}
                </div>
              </div>
              <div className="mt-2">
                Next Order:{" "}
                {d.nextOrders?.length === 0 ? (
                  "No Order"
                ) : (
                  <b>#{d?.nextOrders[0]?.tranId} </b>
                )}
              </div>
            </Card>
          </div>
        ));

  console.log("techAllDetails=>", allTechd);
  return (
    <Layout
      sidebarContent={
        <TechSidebar
          arg={{ pageC, setPageC, totaltech, searchData, setSearchData }}
        >
          {sidebarData()}
        </TechSidebar>
      }
    >
      <div className="contentclss">
        <div className="ordercls">{techAllDetails.name}</div>
        <div className="sub2container mt-4">
          <Content
            arg={{
              activeEdit,
              setActiveEdit,
              handleActiveEdit,
              setRefreshData,
              openOrders,
              setOpenOrders,
              updateTech,
              setUpdateTech,
              setUpdateEmail,
              handleExitwithoutSaving,
              techAllDetails,
              setTechAllDetails,
            }}
          />
        </div>
      </div>
    </Layout>
  );
};

export default Index;
